"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestHttpError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const SvcBillingAutomationHttpError_1 = require("./SvcBillingAutomationHttpError");
class BadRequestHttpError extends SvcBillingAutomationHttpError_1.SvcBillingAutomationHttpError {
    constructor(message, previous) {
        super(http_status_codes_1.default.BAD_REQUEST, message, previous);
    }
}
exports.BadRequestHttpError = BadRequestHttpError;
//# sourceMappingURL=BadRequestHttpError.js.map